import victory from './victory.png';
import theRightWay from './the-right-way.png';
import stockbroker from './stockbroker.png';
import samariaRealEstate from './samaria-real-estate.png';
import requires from './requires.png';
import replace from './replace.png';
import remax from './remax.png';
import reich from './reich.png';
import realeStateDolutions from './reale-state-dolutions.png';
import realEstateWell from './real-estate-well.png';
import realEstateSolutions from './real-estate-solutions.png';
import quickRealEstate from './quick-real-estate.png';
import provence from './provence.png';
import maxHome from './max-home.png';
import homeland from './homeland.png';
import homeInIsrael from './home-in-Israel.png';
import hmInvest from './hm-invest.png';
import govAri from './gov-ari.png';
import goldmanRealEstate from './goldman-real-estate.png';
import goReality from './go-reality.png';
import friendshipFoundation from './friendship-foundation.png';
import franzi from './franzi.png';
import fiveRealEstateConsultants from './five-real-estate-consultants.png';
import firstRealEstate from './first-real-estate.png';
import eranDrori from './eran-drori.png';
import elios from './elios.png';
import claireWilliams from './claire-williams.png';
import apartmentsFirst from './apartments-first.png';
import angloSaxon from './anglo-saxon.png';
import group from './7Group.png';

export default {
    victory,
    theRightWay,
    stockbroker,
    samariaRealEstate,
    requires,
    replace,
    remax,
    reich,
    realeStateDolutions,
    realEstateWell,
    realEstateSolutions,
    quickRealEstate,
    provence,
    maxHome,
    homeland,
    homeInIsrael,
    hmInvest,
    govAri,
    goldmanRealEstate,
    goReality,
    friendshipFoundation,
    franzi,
    fiveRealEstateConsultants,
    firstRealEstate,
    eranDrori,
    elios,
    claireWilliams,
    apartmentsFirst,
    angloSaxon,
    group
};
